import { useRoles } from "@/features/admin/hooks/useRoles";

/**
 * Followups #11 — Minimum-role selector.
 *
 * Dropdown sourced from /api/roles. Replaces the free-text input that
 * previously appeared on KeyEntryPanel / QaPanel / VerificationPanel /
 * SupervisorPanel.
 *
 * Legacy-value handling: if the saved `value` doesn't match any current
 * tenant role (e.g. an older config with "keyer", "verifier"), the value
 * is still rendered as an option labeled "(legacy)" so the saved data
 * is not silently lost. Users can pick any current role to update.
 */
interface Props {
  value: string;
  onChange: (next: string) => void;
}

export function MinimumRoleSelect({ value, onChange }: Props) {
  const { roles, isLoading, error } = useRoles();

  const matched = roles.some((r) => r.name === value);
  const hasLegacy = !isLoading && !error && value && !matched;

  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} disabled={isLoading}>
      {hasLegacy ? <option value={value}>{value} (legacy)</option> : null}
      {roles.map((r) => (
        <option key={r.id} value={r.name}>
          {r.name}
        </option>
      ))}
      {isLoading ? <option value={value}>{value || "Loading..."}</option> : null}
      {error ? <option value={value}>Failed to load roles</option> : null}
    </select>
  );
}
